import React, { type ReactNode } from 'react';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import type { AssetsLayout as AssetsLayoutType } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyAssetsLayout = lazyForPaint<typeof AssetsLayoutType>(
	() =>
		import(/* webpackChunkName: "async-assets-layout" */ './index').then(
			(module) => module.AssetsLayout,
		),
	{ ssr: false },
);

export const AssetsLayoutWithoutUfoLoadHold = ({ children }: { children: ReactNode }) => (
	<Placeholder name="assets-layout-async">
		<LazyAssetsLayout>{children}</LazyAssetsLayout>
	</Placeholder>
);

export const AssetsLayoutWithUfoLoadHold = ({ children }: { children: ReactNode }) => (
	<Placeholder name="assets-layout-async" fallback={<UFOLoadHold name="assets-layout-async" />}>
		<LazyAssetsLayout>{children}</LazyAssetsLayout>
	</Placeholder>
);

export const AssetsLayout = componentWithFG(
	'add_ufo_hold_to_assets_schema_page',
	AssetsLayoutWithUfoLoadHold,
	AssetsLayoutWithoutUfoLoadHold,
);
